import React from 'react';
import isNull from 'lodash/isNull';
import PropTypes from 'prop-types';
import createScoreBoard from '../../score-board/createScoreBoard';
import { FIRST_ELEMENT_KEY, SCOREBOARD_WRAPPER_CLASS } from './constants';
import { getWsInterface } from '../../../../spa/Utils/Websockets.js';
import classNames from 'classnames';
import './styles/scoreboard-wrapper.scss';

class Scoreboard extends React.Component {

    constructor(props) {
        super(props);

        this.wsInterface = getWsInterface();
        this.scoreElement = null;
        this.scoreBoard = null;
        this.connected = false;
        this.wsInplayHandler = null;

        this.getEventsSubscriptionList = this.getEventsSubscriptionList.bind(this);
        this.handleScoreBoard = this.handleScoreBoard.bind(this);
        this.createScoreBoard = this.createScoreBoard.bind(this);
        this.handleConnect = this.handleConnect.bind(this);
        this.handleUpdateEvents = this.handleUpdateEvents.bind(this);
    }

    static propTypes = {
        sport: PropTypes.string.isRequired,
        event: PropTypes.object.isRequired,
    };

    componentDidMount() {
        this.handleScoreBoard();
        /**
         * @todo AM-2540 rename to wsMainSocketHandler for clarity - no inplay/preplay sockets any more
         */
        if (!this.wsInplayHandler) {
            this.wsInplayHandler = this.wsInterface.requestHandler('mainSocket');
        }

        if (this.wsInplayHandler) {
            this.wsInplayHandler.onConnection(this.handleConnect, true);
        }
    }

    getEventsSubscriptionList() {
        try {
            const markets = Object.keys(this.props.event.markets);

            return [{
                event_id: parseInt(this.props.event.id, 10),
                market_id: parseInt(markets[FIRST_ELEMENT_KEY], 10),
            }];
        } catch (e) {
            return [];
        }
    }

    handleConnect() {
        this.connected = true;
        this.wsInplayHandler.subscribe(this.getEventsSubscriptionList());
        this.connected = true;
        this.handleUpdate();
    }

    handleUpdate() {
        this.wsInplayHandler.registerHandler('inplay_update', this.handleUpdateEvents);
        this.wsInplayHandler.registerHandler('price_update', this.handleUpdateEvents);
    }

    handleUpdateEvents(msg) {
        msg.events.forEach((ev) => {
            if (this.props.event.id === ev.id) {
                this.scoreBoard.update(ev);
            }
        });
    }

    handleScoreBoard() {
        if (isNull(this.scoreBoard)) {
            this.createScoreBoard();
        } else {
            this.scoreBoard.update(this.props.event);
        }
    }

    createScoreBoard() {
        this.scoreBoard = createScoreBoard(this.props.sport, this.props.event, this.props.event.isUsFormat);
        this.scoreElement.appendChild(this.scoreBoard.el);
    }

    render() {
        const classes = classNames(SCOREBOARD_WRAPPER_CLASS, {
            [`${SCOREBOARD_WRAPPER_CLASS}--three_market_view`] : this.props.event.usesThreeMarketView,
        });

        return (
            <div className={classes} ref={(el) => { this.scoreElement = el; }}></div>
        );
    }
}

export default Scoreboard;
